const postPayment = state => state.postPayment.data
const errorPostPayment = state => state.errorPostPayment
const isLoadingPostPayment = state => state.isLoadingPostPayment

const listPckgMembership = state => state.listPckgMembership.data
const errorPckgMembership = state => state.errorPckgMembership
const isLoadingPckgMembership = state => state.isLoadingPckgMembership

const listPckgDesignShop = state => state.listPckgDesignShop.data
const errorPckgDesignShop = state => state.errorPckgDesignShop
const isLoadingPckgDesignShop = state => state.isLoadingPckgDesignShop

const listPckgProduct = state => state.listPckgProduct.data
const errorPckgProduct = state => state.errorPckgProduct
const isLoadingPckgProduct = state => state.isLoadingPckgProduct

const listPckgAdditional = state => state.listPckgAdditional.data
const errorPckgAdditional = state => state.errorPckgAdditional
const isLoadingPckgAdditional = state => state.isLoadingPckgAdditional

const postCekPromo = state => state.postCekPromo.data
const errorCekPromo = state => state.errorCekPromo
const isLoadingCekPromo = state => state.isLoadingCekPromo

export default {
  postPayment,
  errorPostPayment,
  isLoadingPostPayment,

  listPckgMembership,
  errorPckgMembership,
  isLoadingPckgMembership,

  listPckgDesignShop,
  errorPckgDesignShop,
  isLoadingPckgDesignShop,

  listPckgProduct,
  errorPckgProduct,
  isLoadingPckgProduct,

  listPckgAdditional,
  errorPckgAdditional,
  isLoadingPckgAdditional,

  postCekPromo,
  errorCekPromo,
  isLoadingCekPromo
}



// WEBPACK FOOTER //
// ./src/store/modules/alibabaPayment/getters.js